import { useEffect, useRef } from 'react';

export const useUnMount = (fn: () => void) => {
  const fnRef = useRef(fn);

  fnRef.current = fn;

  useEffect(() => () => fnRef.current(), []);
};
